(() => {
  const desktopQuery = window.matchMedia('(min-width: 768px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lenis;
  let topbarResizeObserver;

  const syncTopbarHeight = () => {
    const topbar = document.querySelector('.topbar-section');
    const height = topbar?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--topbar-height', `${height}px`);
  };

  const observeTopbar = () => {
    syncTopbarHeight();
    topbarResizeObserver?.disconnect();

    const topbar = document.querySelector('.topbar-section');
    if (topbar && window.ResizeObserver) {
      topbarResizeObserver = new ResizeObserver(syncTopbarHeight);
      topbarResizeObserver.observe(topbar);
    }
  };

  const isOverlayOpen = () => (
    document.body.classList.contains('activity-waterfall-open') ||
    document.body.classList.contains('slideshow-video-modal-open') ||
    document.body.classList.contains('has-modal-open') ||
    document.body.classList.contains('overflow-hidden') ||
    document.body.classList.contains('overflow-hidden-tablet') ||
    document.querySelector('drawer-element[open], modal-element[open], cart-drawer[open], details-modal[open]')
  );

  const syncOverlayState = () => {
    if (!lenis) return;

    if (document.body.classList.contains('activity-waterfall-open')) {
      lenis.stop();
      return;
    }

    if (isOverlayOpen()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  const destroy = () => {
    if (!lenis) return;

    lenis.destroy();
    lenis = undefined;
    delete window.desviewLenis;
  };

  const initialize = () => {
    const shouldUseSmoothScroll = desktopQuery.matches && !reducedMotionQuery.matches && !window.Shopify?.designMode;

    if (!shouldUseSmoothScroll) {
      destroy();
      return;
    }

    if (lenis || !window.Lenis) return;

    lenis = new window.Lenis({
      autoRaf: true,
      duration: 0.75,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.9,
      allowNestedScroll: true,
      anchors: false
    });
    window.desviewLenis = lenis;
    syncOverlayState();
  };

  const scheduleInitialize = () => window.requestAnimationFrame(initialize);

  document.addEventListener('drawer:afterShow', syncOverlayState);
  document.addEventListener('drawer:afterHide', syncOverlayState);
  document.addEventListener('modal:afterShow', syncOverlayState);
  document.addEventListener('modal:afterHide', syncOverlayState);
  window.addEventListener('resize', scheduleInitialize, { passive: true });
  window.addEventListener('resize', syncTopbarHeight, { passive: true });
  desktopQuery.addEventListener('change', initialize);
  reducedMotionQuery.addEventListener('change', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observeTopbar();
      initialize();
    }, { once: true });
  } else {
    observeTopbar();
    initialize();
  }
})();
